<template>
 <div v-if="!this.$store.state.general.user.verified">
      <plans msgtitle="You currently do not have access to General Insights"
            msgdescription="Please choose a plan to pay to enjoy the General Insights feature"
      ></plans>
    </div>
    <div v-else>

        <file-insights :segmentID="$route.params.id" />
    </div>

</template>

<script>
  import FileInsights from '@/components/FileInsights';
  import Plans from './Plans/Plans'
  import VueSweetalert2 from 'vue-sweetalert2';
  import swal from 'sweetalert2';
  window.Swal = swal;

  export default {
    name: 'Dashboard',
    components: { FileInsights, Plans },

  
  };

</script>
